import { useQuery } from '@apollo/client';
import { graphql } from '../../__generated__';
import { BenefitCode } from '../../__generated__/graphql';

export const doctorCustomerPromoCodesQuery = graphql(`
  query getDoctorCustomerReferCode($customerId: String) {
    benefitCodesForCustomer(customerId: $customerId) {
      customerId
      code
      title
      active
      singleUse
      discount
      discountType
      services
      type
      spendQualify
      global
      __typename
    }
  }
`);

export const useDoctorCustomerPromoCodes = (
  customerId: string,
  onLoaded?: (activeProductCodes: BenefitCode[]) => void,
) => {
  const { data, loading } = useQuery(doctorCustomerPromoCodesQuery, {
    variables: { customerId },
    skip: !customerId,
    onCompleted: (loadedData) => {
      if (
        onLoaded &&
        loadedData?.benefitCodesForCustomer &&
        loadedData?.benefitCodesForCustomer?.length > 0
      ) {
        const activeProductCodes = (loadedData?.benefitCodesForCustomer?.filter(
          (a) => a?.active && ['products', 'delivery'].includes(a?.type ?? ''),
        ) ?? []) as BenefitCode[];

        onLoaded(activeProductCodes);
      }
    },
  });

  const activeCodes = (data?.benefitCodesForCustomer?.filter((a) => a?.active) ??
    []) as BenefitCode[];

  const activeProductCodes = (data?.benefitCodesForCustomer?.filter(
    (a) => a?.active && ['products', 'delivery'].includes(a?.type ?? ''),
  ) ?? []) as BenefitCode[];

  const activeServiceCodes = (data?.benefitCodesForCustomer?.filter(
    (a) => a?.active && ['services'].includes(a?.type ?? ''),
  ) ?? []) as BenefitCode[];

  const codes = [...(data?.benefitCodesForCustomer ?? [])]?.sort((a, b) =>
    (a?.title ?? '')?.localeCompare(b?.title ?? ''),
  );

  return {
    loading,
    activeCodes,
    activeProductCodes,
    activeServiceCodes,
    codes,
  };
};
